export default class VoyageMeshData {
    constructor(voyageId, computationId, high, low) {
        this.voyageId = voyageId
        this.computationId = computationId
        this.high = high
        this.low = low
    }

    get highFeaturesDataList() {
        return this.high.map((datum) => ({
            'coordinates': [datum.longitude, datum.latitude],
            'position': `${datum.position}`,
        }))
    }

    get lowFeaturesDataList() {
        return this.low.map((datum) => ({
            'coordinates': [datum.longitude, datum.latitude],
            'position': `${datum.position}`,
        }))
    }
}
